<template>
  <div class="container-fluid style-guide">
    <d-row>
      <d-col cols="2" class="my-4">
        <div class="bg-white border position-sticky p-3" style="top: 1.5rem">
          <h2>
            Legenda
          </h2>

          <ul class="nav flex-column">
            <li class="nav-item">
              <a class="nav-link" href="#inputs">
                Input fields
              </a>
            </li>

            <li class="nav-item">
              <a class="nav-link" href="#buttons">
                Buttons
              </a>
            </li>

            <li class="nav-item">
              <a class="nav-link" href="#typography">
                Typography
              </a>
            </li>
          </ul>
        </div>
      </d-col>

      <d-col cols="10">
        <d-row id="inputs" class="style-guide-inputs mt-4 mb-5">
          <d-col cols="12" class="my-2">
            <h2>
              Input fields 12
            </h2>
          </d-col>

          <d-col cols="4" class="bg-white p-3">
            <h3>
              Input fields on white background
            </h3>

            <form-group v-model="d_data.placeholder" label="Bg Wh Placeholder" placeholder="Placeholder" />

            <form-group v-model="d_data.filled" label="Bg Wh Active Filled" placeholder="Active Filled" />

            <form-group v-model="d_data.emptyField" label="Bg Wh Active Empty" placeholder="Active Empty" />

            <form-group v-model="d_data.disabled" :disabled="true" label="Bg Wh Disabled Filled" placeholder="Disabled Filled" />

            <form-group v-model="d_data.error" :error="d_data.error" label="Bg Wh Error Filled" placeholder="Error Filled" />

            <form-group v-model="d_data.placeholder" label="Bg Wh Active Filled No Label" placeholder="Active Filled No Label" :showLabel="false" />

            <form-group v-model="d_data.filled" label="Bg Wh Password Filled">
              <template #input>
                <password-input v-model="d_data.filled" placeholder="Bg Wh Password Filled" />
              </template>
            </form-group>

            <form-group v-model="d_data.checked" :showLabel="false">
              <template #input>
                <d-checkbox inline v-model="d_data.checked">
                  Bg Wh Inline checkbox
                </d-checkbox>
              </template>
            </form-group>
          </d-col>

          <d-col cols="4" class="p-3">
            <h3>
              Input fields on default background
            </h3>

            <form-group v-model="d_data.placeholder" label="Bg Def Placeholder" placeholder="Placeholder" />

            <form-group v-model="d_data.filled" label="Bg Def Active Filled" placeholder="Active Filled" />

            <form-group v-model="d_data.emptyField" label="Bg Def Active Empty" placeholder="Active Empty" />

            <form-group v-model="d_data.disabled" :disabled="true" label="Bg Def Disabled Filled" placeholder="Disabled Filled" />

            <form-group v-model="d_data.error" :error="d_data.error" label="Bg Def Error Filled" placeholder="Error Filled" />

            <form-group v-model="d_data.placeholder" label="Bg Def Active Filled No Label" placeholder="Active Filled No Label" :showLabel="false" />

            <form-group v-model="d_data.filled" label="Bg Def Password Filled">
              <template #input>
                <password-input v-model="d_data.filled" placeholder="Bg Def Password Filled" />
              </template>
            </form-group>

            <form-group v-model="d_data.checked" :showLabel="false">
              <template #input>
                <d-checkbox inline v-model="d_data.checked">
                  Bg Def Inline checkbox
                </d-checkbox>
              </template>
            </form-group>
          </d-col>

          <d-col cols="4">
            <d-card>
              <d-card-body>
                <h3>
                  Input fields on Card
                </h3>

                <form-group v-model="d_data.placeholder" label="Card Placeholder" placeholder="Placeholder" />

                <form-group v-model="d_data.filled" label="Card Active Filled" placeholder="Active Filled" />

                <form-group v-model="d_data.emptyField" label="Card Active Empty" placeholder="Active Empty" />

                <form-group v-model="d_data.disabled" :disabled="true" label="Card Disabled Filled" placeholder="Disabled Filled" />

                <form-group v-model="d_data.error" :error="d_data.error" label="Card Error Filled" placeholder="Error Filled" />

                <form-group v-model="d_data.placeholder" label="Card Active Filled No Label" placeholder="Active Filled No Label" :showLabel="false" />

                <form-group v-model="d_data.filled" label="Card Password Filled">
                  <template #input>
                    <password-input v-model="d_data.filled" placeholder="Card Password Filled" />
                  </template>
                </form-group>

                <form-group v-model="d_data.checked" :showLabel="false">
                  <template #input>
                    <d-checkbox inline v-model="d_data.checked">
                      Card Inline checkbox
                    </d-checkbox>
                  </template>
                </form-group>
              </d-card-body>
            </d-card>
          </d-col>
        </d-row>

        <hr />

        <d-row id="buttons" class="style-guide-buttons mb-5">
          <d-col cols="12" class="my-2">
            <h2>
              Buttons
            </h2>
          </d-col>

          <d-col cols="12" class="mb-2">
            <h3>
              Click a theme button to change the button variants below
            </h3>

            <d-button @click="d_buttonTheme = 'primary'" theme="primary" class="mx-2">
              Primary
            </d-button>

            <d-button @click="d_buttonTheme = 'secondary'" theme="secondary" class="mx-2">
              Secondary
            </d-button>

            <d-button @click="d_buttonTheme = 'success'" theme="success" class="mx-2">
              Success
            </d-button>

            <d-button @click="d_buttonTheme = 'info'" theme="info" class="mx-2">
              Info
            </d-button>

            <d-button @click="d_buttonTheme = 'warning'" theme="warning" class="mx-2">
              Warning
            </d-button>

            <d-button @click="d_buttonTheme = 'danger'" theme="danger" class="mx-2">
              Danger
            </d-button>

            <d-button @click="d_buttonTheme = 'light'" theme="light" class="mx-2">
              Light
            </d-button>

            <d-button @click="d_buttonTheme = 'dark'" theme="dark" class="mx-2">
              Dark
            </d-button>
          </d-col>

          <d-col cols="12">
            <h3 class="my-3">
              Button Variants
            </h3>
          </d-col>

          <d-col cols="12" class="mb-2">
            <d-button :theme="d_buttonTheme" class="mx-2">
              Default
            </d-button>

            <d-button :theme="d_buttonTheme" pill class="mx-2">
              Pill
            </d-button>

            <d-button :theme="d_buttonTheme" squared class="mx-2">
              Squared
            </d-button>

            <d-button :theme="d_buttonTheme" active class="mx-2">
              Active
            </d-button>

            <d-button :theme="d_buttonTheme" disabled class="mx-2">
              Disabled
            </d-button>

            <d-button :theme="d_buttonTheme" size="lg" class="mx-2">
              Large
            </d-button>

            <d-button :theme="d_buttonTheme" size="sm" class="mx-2">
              Small
            </d-button>
          </d-col>

          <d-col cols="12" class="mb-2">
            <d-button :theme="d_buttonTheme" outline class="mx-2">
              Outline
            </d-button>

            <d-button :theme="d_buttonTheme" outline pill class="mx-2">
              Pill
            </d-button>

            <d-button :theme="d_buttonTheme" outline squared class="mx-2">
              Squared
            </d-button>

            <d-button :theme="d_buttonTheme" outline active class="mx-2">
              Active
            </d-button>

            <d-button :theme="d_buttonTheme" outline disabled class="mx-2">
              Disabled
            </d-button>

            <d-button :theme="d_buttonTheme" outline size="lg" class="mx-2">
              Large
            </d-button>

            <d-button :theme="d_buttonTheme" outline size="sm" class="mx-2">
              Small
            </d-button>
          </d-col>
        </d-row>

        <hr />

        <d-row id="typography" class="style-guide-text mb-5">
          <d-col cols="12" class="my-2">
            <h2>
              Typography
            </h2>
          </d-col>

          <d-col cols="12" class="my-2">
            <h3>
              Headers
            </h3>
          </d-col>

          <d-col cols="12" class="my-2">
            <div class="h1 mb-3">
              H1 Heading
            </div>

            <div class="h2 mb-3">
              H2 Heading
            </div>

            <div class="h3 mb-3">
              H3 Heading
            </div>

            <div class="h4 mb-3">
              H4 Heading
            </div>

            <div class="h5 mb-3">
              H5 Heading
            </div>

            <div class="h6 mb-3">
              H6 Heading
            </div>
          </d-col>

          <d-col cols="12" class="my-2">
            <h3>
              Text
            </h3>
          </d-col>

          <d-col cols="12" class="my-2">
            <div>
              Normal text; font family: Ubuntu
            </div>

            <div class="label">
              Label text; font family: Ubuntu
            </div>

            <div class="invalid-feedback">
              Invalid feedback text; font family: Ubuntu
            </div>

            <a href="#">
              Link text; font family: Ubuntu
            </a>
          </d-col>
        </d-row>

        <hr />
      </d-col>
    </d-row>
  </div>
</template>

<script>
import PasswordInput from '@/components/common/form/PasswordInput';

export default {
  name: 'style-guide',
  components: { PasswordInput },
  data () {
    return {
      d_data: {
        checked: true,
        disabled: 'Disabled',
        error: 'Error',
        filled: 'Filled',
      },
      d_buttonTheme: 'primary',
    };
  },
}
</script>
